import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "@environments/environment";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { ParamsService } from "@shared/Services/params.service";

import { EstadoCuentaClienteParamsEmail, GetEstadoCuentaClienteParams } from "../estado-cuenta-client.interface";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class EstadoCuentaClienteRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  public getEstadoCuentaCliente(estadoCuentaParams: GetEstadoCuentaClienteParams): Observable<Blob> {
    const params = this.paramsService.mapRequestParams(estadoCuentaParams);
    return this.http.get<Blob>(`${enlineaBackendUrl}/api/ars/Intermediarios/EstadoCuentaCliente`, {
      params,
      responseType: "blob" as any,
    });
  }

  public sendEmailNotification(estadoCuentaParams: EstadoCuentaClienteParamsEmail): Observable<ShareMessageResponse> {
    return this.http.post<ShareMessageResponse>(`${enlineaBackendUrl}/api/ars/accountstatement/email`, estadoCuentaParams);
  }
}
